module.exports = __webpack_public_path__ + "img/img25.e9cc2b56.svg";